import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './SimulatedRemoveModalMessages';

function SimulatedRemoveModal({ intl, isOpen, onClose, onContinue }) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon="pe-7s-close-circle"
      title={intl.formatMessage(messages.title)}
      subtitle={intl.formatMessage(messages.subtitle)}
      buttons={[
        {
          label: intl.formatMessage(messages.cancel),
          onClick: onClose,
        },
        {
          label: intl.formatMessage(messages.continue),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    />
  );
}

const mapStateToProps = ({ simulatedContentMap }) => ({
  ...simulatedContentMap,
});

export default compose(
  injectIntl,
  connect(mapStateToProps),
)(SimulatedRemoveModal);
